import React from 'react'
import { Layout, Menu, Input } from 'antd';
import { withRouter } from "react-router-dom";
// import XiongLogo from '../../assets/svg/xiong.svg'
import YroooLogo from '../../assets/images/yrooo_logo_2.png'
import './index.less'
import { connect } from 'react-redux'
import { homeUpdateSearchKey } from '@/store/actions'

const { Search } = Input
const { Header, Content, Footer } = Layout

@connect(
  state => ({
    homeSearchKey: state.homeSearchKey
  }),
  { homeUpdateSearchKey }
)
class DefaultLayout extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      nav: [
        { name: '首页', path: '/' },
        { name: '关于', path: '/about' },
        { name: '登录', path: '/login' },
        { name: '管理', path: '/admin' }
      ],
      pathname: ''
    }
  }

  handleClick = (path) => {
    this.props.history.push({
      pathname: path
    });
  }

  onSearch = (key) => {
    console.log(key)
    this.props.homeUpdateSearchKey(key)
  }

  locationHome = () => {
    this.props.history.push({
      pathname: '/'
    })
    document.documentElement.scrollTop = 0
  }

  componentWillMount () {
    this.setState({
      pathname: this.props.history.location.pathname
    })
  }

  render () {
    const { state, handleClick, onSearch, locationHome } = this
    const { pathname } = state

    return (
      <div id="blog-layout-container">
        <Layout className="blog-components-layout">
          <div className="blog-layout-background-mark"></div>
          <div className="blog-layout-front-container" style={{ marginTop: 64 }}>
            <Header className="blog-layout-header" style={{ position: 'fixed', top: '0', zIndex: 10, width: '100%' }}>
              <div className="blog-header-wrapper">
                <div className="logo" onClick={locationHome}>
                  光的随笔Go
                  {/* <img src={YroooLogo} alt="logo" /> */}
                  <div className="logo-title">生活处处充满创意！</div>
                </div>
                <div className="blog-header-right">
                  <div className="search-container">
                    <div className="search-wrapper">
                      <Search placeholder="搜索你所想..." onSearch={onSearch} allowClear />
                    </div>
                  </div>
                  <Menu className="blog-layout-header-menu" mode="horizontal" defaultSelectedKeys={[pathname]}>
                    {
                      state.nav.map(item => {
                        return (
                          <Menu.Item key={item.path} onClick={() => handleClick(item.path)}>{item.name}</Menu.Item>
                        )
                      })
                    }
                  </Menu>
                </div>
              </div>
            </Header>
            <Content className="site-layout">
              <div className="site-layout-background">
                {this.props.children}
              </div>
            </Content>
            <Footer className="blog-footer" style={{ textAlign: 'center' }}>
              <div className="blog-footer-wrapper">
                <div className="footer-left">nuiii.com © {new Date().getYear() + 1900} Created by Guang</div>
                <div className="footer-right" onClick={() => window.location = 'https://beian.miit.gov.cn/'}>粤ICP备16122223号</div>
              </div>
            </Footer>
          </div>
        </Layout>
      </div>
    )
  }
}

export default withRouter(DefaultLayout)
